(() => {
  if (window.__HF_TIMELINE_INIT__) return;
  window.__HF_TIMELINE_INIT__ = 1;

  const DESKTOP = { START_OFFSET_VH: 70, END_PADDING_VH: 30 };
  const MOBILE = { START_OFFSET_VH: 60, END_PADDING_VH: 20 };
  const DESKTOP_FADE = { ZERO_OFFSET_PX: 200, BAND_PX: 200 };
  const MOBILE_FADE = { ZERO_OFFSET_PX: 50, BAND_PX: 200 };

  function getLineHeightPx(el) {
    const cs = getComputedStyle(el);
    let lh = parseFloat(cs.lineHeight);
    if (!Number.isFinite(lh)) lh = parseFloat(cs.fontSize) * 1.2;
    return lh || 0;
  }

  function applyTitleStyle(root) {
    const style = root.dataset.titleStyle || 'h3';
    const styleMobile = root.dataset.titleStyleMobile || style;
    const cls = `hf-typo-preset--${style}`;
    const clsMobile = `hf-typo-preset--mobile-${styleMobile}`;
    root.querySelectorAll('.scroll-item__title').forEach((el) => {
      el.classList.add(cls);
      el.classList.add(clsMobile);
    });
  }

  function getVisibleItems(list) {
    return Array.from(list.querySelectorAll('.scroll-list-block-item'))
      .filter((el) => el.offsetParent !== null);
  }

  function computeGeom(root, items) {
    const rootRect = root.getBoundingClientRect();
    const dotOffsetY = parseFloat(getComputedStyle(root).getPropertyValue('--dot-offset-y')) || 0;
    const firstTitle = items[0].querySelector('.scroll-item__title') || items[0];
    const firstRect = firstTitle.getBoundingClientRect();
    const firstDotY = firstRect.top + window.scrollY + getLineHeightPx(firstTitle) / 2 + dotOffsetY;
    const lastItem = items[items.length - 1];
    const lastBottomY = lastItem.getBoundingClientRect().bottom + window.scrollY;
    return {
      topAbs: firstDotY,
      topLocal: firstDotY - (rootRect.top + window.scrollY),
      height: Math.max(0, lastBottomY - firstDotY),
    };
  }

  function initTimeline(root) {
    if (!root || root.dataset.hfTimelineInit === '1') return;
    root.dataset.hfTimelineInit = '1';

    const list = root.querySelector('.scroll-list-blocks');
    const line = root.querySelector('.scroll-list-blocks-line');
    if (!list || !line) return;

    list.style.webkitMaskRepeat = 'no-repeat';
    list.style.maskRepeat = 'no-repeat';
    list.style.webkitMaskSize = '100% 100%';
    list.style.maskSize = '100% 100%';
    list.style.webkitMaskPosition = '0 0';
    list.style.maskPosition = '0 0';
    list.style.willChange = '-webkit-mask-image, mask-image';

    applyTitleStyle(root);

    let scheduled = false;

    function update() {
      const items = getVisibleItems(list);
      if (items.length < 1) {
        line.style.height = '0px';
        line.style.setProperty('--line-scale', '0');
        list.style.webkitMaskImage = 'none';
        list.style.maskImage = 'none';
        return;
      }

      const geom = computeGeom(root, items);
      const listRect = list.getBoundingClientRect();
      if (geom.height <= 0) {
        line.style.height = '0px';
        line.style.setProperty('--line-scale', '0');
        list.style.webkitMaskImage = 'none';
        list.style.maskImage = 'none';
        return;
      }

      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      const opts = isMobile ? MOBILE : DESKTOP;
      const fadeOpts = isMobile ? MOBILE_FADE : DESKTOP_FADE;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const vhPct = vh / 100;
      const startAbs = geom.topAbs - opts.START_OFFSET_VH * vhPct;
      const endAbs = geom.topAbs + geom.height - vh + opts.END_PADDING_VH * vhPct;
      const range = Math.max(1, endAbs - startAbs);
      const progress = Math.max(0, Math.min(1, (window.scrollY - startAbs) / range));

      const gViewportY = vh - Math.max(0, Math.min(vh - 1, fadeOpts.ZERO_OFFSET_PX | 0));
      const yViewportY = gViewportY - Math.max(1, fadeOpts.BAND_PX | 0);
      let bandEnd = gViewportY - listRect.top;
      let bandStart = yViewportY - listRect.top;
      if (bandStart > bandEnd) {
        const tmp = bandStart;
        bandStart = bandEnd;
        bandEnd = tmp;
      }
      const mask = `linear-gradient(to bottom,\n        rgba(0,0,0,1) -100000px,\n        rgba(0,0,0,1) ${bandStart}px,\n        rgba(0,0,0,0) ${bandEnd}px,\n        rgba(0,0,0,0) 100000px)`;

      line.style.top = geom.topLocal + 'px';
      line.style.height = geom.height + 'px';
      line.style.setProperty('--line-scale', progress.toFixed(4));
      list.style.webkitMaskImage = mask;
      list.style.maskImage = mask;
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        update();
      });
    }

    update();

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule, { passive: true });
    }

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(schedule);
      ro.observe(list);
      list.querySelectorAll('.scroll-list-block-item').forEach((el) => ro.observe(el));
    }

    if ('fonts' in document) document.fonts.ready.then(schedule);
    window.addEventListener('load', schedule, { once: true });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hf-timeline]').forEach(initTimeline);
  }

  function deferInitAll(scope) {
    const run = () => initAll(scope);
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 1500 });
    } else {
      setTimeout(run, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => deferInitAll());
  } else {
    deferInitAll();
  }

  document.addEventListener('shopify:section:load', (e) => deferInitAll(e.target));
  document.addEventListener('shopify:block:load', (e) => deferInitAll(e.target));
})();
